import api from "api/api";

export const createBillingClientQuery = async ({ data, userScope }) =>
  await api.post(`/directory/billing_client?scope=${userScope}`, data);

export const getBillingClientByIdQuery = async ({ id, userScope }) =>
  await api.get(`/directory/billing_client/id/${id}?scope=${userScope}`);

export const getBillingClientByIdArrayQuery = async ({ ids, userScope }) =>
  await api.get(`/directory/billing_client/ids/${ids}?scope=${userScope}`);

export const updateBillingClientQuery = async ({ id, data, userScope }) =>
  await api.put(`/directory/billing_client/id/${id}?scope=${userScope}`, data);

export const deleteBillingClientQuery = async ({ id, userScope }) =>
  await api.delete(`/directory/billing_client/id/${id}?scope=${userScope}`);

export const getBillingCompaniesBySiren = async ({ siren, userScope }) =>
  await api.get(`/directory/billing_client/siren/${siren}?scope=${userScope}`);

export const getBillingCompaniesBySlug = async ({ slug, userScope }) =>
  await api.get(`/directory/billing_client/slug/${slug}?scope=${userScope}`);

export const searchBillingClientByNameQuery = async ({ search, userScope }) =>
  await api.get(
    `/directory/search/billing_client?search=${search}&scope=${userScope}`
  );
